import { __assign, __rest } from "tslib";
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { createBasePlugin } from 'wix-rich-content-plugin-commons';
import createMentionPlugin from 'draft-js-mention-plugin';
import { positionSuggestions } from './positionSuggestions';
import { MENTION_TYPE } from 'wix-rich-content-common';
import pluginStyles from './styles.scss';
/** Provides the mention plugin base config. We use draft-js-mention-plugin under the hood. */
function externalMentionPluginCreator(pluginConfig) {
    var externalMentionPluginInstance = createMentionPlugin(__assign({ entityMutability: 'IMMUTABLE', mentionPrefix: '@', theme: pluginStyles, positionSuggestions: positionSuggestions(pluginConfig) }, pluginConfig));
    var MentionSuggestions = externalMentionPluginInstance.MentionSuggestions;
    var MentionPortal = function (props) {
        useEffect(function () {
            var container = document.getElementById('editor-mention-portal');
            if (!container) {
                var el = document.createElement('div');
                el.id = 'editor-mention-portal';
                document.body.appendChild(el);
            }
        });
        var container = document.getElementById('editor-mention-portal');
        if (!container) {
            return null;
        }
        return ReactDOM.createPortal(React.createElement(MentionSuggestions, __assign({}, props)), container);
    };
    return {
        extras: {
            MentionSuggestions: MentionPortal,
        },
        plugin: function (config) {
            var type = MENTION_TYPE;
            var _a = config, decorator = _a.decorator, helpers = _a.helpers, theme = _a.theme, isMobile = _a.isMobile, t = _a.t, _b = type, _c = _a[_b], settings = _c === void 0 ? {} : _c, rest = __rest(_a, ["decorator", "helpers", "theme", "isMobile", "t", typeof _b === "symbol" ? _b : _b + ""]);
            return createBasePlugin(__assign({ decorator: decorator, theme: theme, type: type, helpers: helpers, isMobile: isMobile, t: t, settings: __assign(__assign({}, settings), { MentionSuggestions: MentionPortal }), defaultPluginData: {} }, rest), externalMentionPluginInstance);
        },
    };
}
export { externalMentionPluginCreator };
//# sourceMappingURL=createMentionPlugin.js.map